var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 14.1673C4.16602 13.7071 4.53911 13.334 4.99935 13.334H14.9994C15.4596 13.334 15.8327 13.7071 15.8327 14.1673C15.8327 14.6276 15.4596 15.0007 14.9994 15.0007H4.99935C4.53911 15.0007 4.16602 14.6276 4.16602 14.1673Z",
    fill: "#CFC8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3328 5.83366V8.9417C13.3328 9.08925 13.372 9.23415 13.4463 9.36159L16.973 15.4073C17.9452 17.074 16.743 19.167 14.8136 19.167H5.18541C3.25593 19.167 2.05375 17.074 3.02596 15.4073L6.55263 9.36159C6.62697 9.23415 6.66615 9.08925 6.66615 8.9417V5.83366C6.20594 5.83362 5.83289 5.46054 5.83289 5.00033C5.83289 4.54011 6.20594 4.16703 6.66615 4.16699C6.66612 4.16699 6.66617 4.16699 6.66615 4.16699H13.3328C13.7931 4.16699 14.1662 4.54009 14.1662 5.00033C14.1662 5.46056 13.7931 5.83366 13.3328 5.83366ZM12.0067 10.2014L15.5334 16.2471C15.8574 16.8026 15.4567 17.5003 14.8136 17.5003H5.18541C4.54225 17.5003 4.14152 16.8026 4.46559 16.2471L7.99226 10.2014C8.21529 9.81904 8.33281 9.38434 8.33281 8.9417V5.83366H11.6661V8.9417C11.6661 9.38434 11.7837 9.81904 12.0067 10.2014Z",
    fill: "#714FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 2.49967C12.1269 2.49967 12.5 2.12658 12.5 1.66634C12.5 1.2061 12.1269 0.833008 11.6667 0.833008C11.2064 0.833008 10.8333 1.2061 10.8333 1.66634C10.8333 2.12658 11.2064 2.49967 11.6667 2.49967Z",
    fill: "#CFC8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 3.33301C8.79357 3.33301 9.16667 2.95991 9.16667 2.49967C9.16667 2.03944 8.79357 1.66634 8.33333 1.66634C7.8731 1.66634 7.5 2.03944 7.5 2.49967C7.5 2.95991 7.8731 3.33301 8.33333 3.33301Z",
    fill: "#CFC8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaker);
export default __webpack_public_path__ + "static/media/beaker.f406e975df5899d0b21cd96f9d9b98aa.svg";
export { ForwardRef as ReactComponent };